import { categoryTabs, latestFeed } from "@/mocks/news";

interface Props {
  active: string;
  onSelect: (id: string) => void;
}

export default function LatestFeed({ active, onSelect }: Props) {
  const list = active === "all" ? latestFeed : latestFeed.filter((n) => n.categoryId === active);

  return (
    <section id="latest" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-bold tracking-widest text-primary-600">
              <i className="ri-flashlight-fill" /> JUST HAPPENED
            </span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              刚刚发生 · 实时速报
            </h2>
            <p className="mt-2 max-w-xl text-sm leading-6 text-foreground-500">
              覆盖早午晚核心时段，事件有突破即推送，用最快速度把现场带到你眼前。
            </p>
          </div>
          <p className="inline-flex items-center gap-2 whitespace-nowrap text-xs font-semibold text-foreground-500">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-pulse-dot absolute inline-flex h-full w-full rounded-full bg-primary-500" />
            </span>
            近 6 小时已更新 {latestFeed.length} 条
          </p>
        </div>

        {/* 分类筛选 */}
        <div className="mt-6 flex flex-wrap gap-2">
          {categoryTabs.map((c) => (
            <button
              key={c.id}
              type="button"
              onClick={() => onSelect(c.id)}
              className={
                "whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors cursor-pointer " +
                (active === c.id
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-700")
              }
            >
              {c.name}
            </button>
          ))}
        </div>

        {/* 列表 */}
        <div className="mt-6 grid gap-5 lg:grid-cols-2">
          {list.map((n, i) => (
            <article
              key={n.id}
              className="group flex flex-col gap-4 rounded-xl border border-background-200 bg-background-50 p-4 transition-all hover:-translate-y-1 hover:border-primary-200 sm:flex-row sm:items-center md:p-5"
            >
              <div
                className={
                  "flex h-14 w-14 shrink-0 items-center justify-center rounded-xl text-background-50 " +
                  (i < 3 ? "bg-primary-500" : "bg-secondary-500")
                }
              >
                <span className="font-heading text-xl font-black">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span
                    className={
                      "inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-[11px] font-bold " +
                      (n.isHot
                        ? "bg-primary-100 text-primary-700"
                        : "bg-accent-100 text-accent-800")
                    }
                  >
                    {n.tag}
                  </span>
                  <span className="inline-flex items-center gap-1 text-[11px] font-medium text-primary-600">
                    <i className="ri-time-line" /> {n.timeText}
                  </span>
                  <span className="inline-flex items-center gap-1 text-[11px] text-foreground-400">
                    <i className="ri-eye-line" /> {n.heat}
                  </span>
                </div>
                <h3 className="mt-1.5 line-clamp-2 font-heading text-[15px] font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-base">
                  {n.title}
                </h3>
                <p className="mt-1 hidden text-xs leading-5 text-foreground-500 sm:block">
                  {n.summary}
                </p>
              </div>
              <a
                href="#live"
                aria-label="查看现场详情"
                className="inline-flex h-9 w-9 shrink-0 items-center justify-center self-start rounded-lg border border-background-200 text-foreground-600 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 sm:self-center cursor-pointer"
              >
                <i className="ri-arrow-right-up-line" />
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}